import React, { useState, useEffect } from "react";

const PasswordGate = ({ children }) => {
  const [password, setPassword] = useState("");
  const [isAllowed, setIsAllowed] = useState(false);
  const [error, setError] = useState("");

  const STATIC_PASSWORD = "u£{kbq%0bIHtR53"; // change this

  useEffect(() => {
    const access = localStorage.getItem("site_access");
    if (access === "granted") {
      setIsAllowed(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password === STATIC_PASSWORD) {
      localStorage.setItem("site_access", "granted");
      setIsAllowed(true);
    } else {
      setError("Wrong password");
    }
  };

  if (!isAllowed) {
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <form onSubmit={handleSubmit}>
          <h3>Enter Website Password</h3>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <br /><br />
          <button type="submit">Enter</button>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      </div>
    );
  }

  return children;
};

export default PasswordGate;